import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../styles/Login.css";
import Footer from "../FooterBn";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  {
    message && (
      <div
        style={{
          color: messageType === "success" ? "green" : "red",
          fontWeight: "bold",
          marginTop: "10px",
        }}
      >
        {message}
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    try {
      const response = await axios.post(
        "https://server.goatteachers.com/api/auth/forgot-password",
        { email },
      );
      setMessage(" A reset link has been sent to your email.");
      setMessageType("success");
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "❌ Failed to send reset link. Please try again.",
      );
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="login-section">
        <div className="login-container">
          <div className="login-box">
            <h2 className="iqWTbl">Reset Password</h2>
            <p className="authquote">
              Enter your email address below. We’ll send you a link to create a
              new password.
            </p>

            {message && <p className="success-message">{message}</p>}
            {error && <p className="error-message">{error}</p>}

            <form onSubmit={handleSubmit} className="login-form">
              <div className="input-group">
                <label htmlFor="email">
                  <strong>Email Address</strong>
                </label>
                <input
                  type="email"
                  id="email"
                  className="input-field"
                  placeholder="yourname@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <button
                type="submit"
                className="login-btn"
                style={{ marginTop: "20px" }}
                disabled={loading}
              >
                {loading ? "Sending..." : "Reset Password"}
              </button>
            </form>

            <p className="back-to-login">
              <a
                onClick={() => navigate("/login")}
                style={{ cursor: "pointer" }}
              >
                ← Back to Login
              </a>
            </p>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
};

export default ForgotPassword;
